import { accountIdFormat } from "@redotech/redo-account-id";
import {
  consolidationGroupIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const updateConsolidationGroup = {
  name: "updateConsolidationGroup" as const,
  input: z.object({
    consolidationGroupId: consolidationGroupIdFormat.schema,
    destinationCenterId: returnsCenterIdFormat.schema,
    merchantAccountIds: z.array(accountIdFormat.schema),
    name: z.string().trim().min(1),
  }),
  output: z.object({}),
};
